import { loadScript } from './util'
import { useEffect } from 'react'
import { Dialog, DialogContent } from '@mui/material'

export function AWSWAFCaptchaModal (props) {
  const { isOpen, captchaLogic } = props

  useEffect(() => loadScript())

  return (
    <Dialog disableEscapeKeyDown open={isOpen}>
      <DialogContent>
        <div ref={(node) => {
          if (node !== null) {
            window.AwsWafCaptcha.renderCaptcha(node, captchaLogic)
          }
        }} />
      </DialogContent>
    </Dialog>
  )
}
